import { Component, Input, OnInit } from '@angular/core';
import { ProductFamilyModel } from '@core/model/productFamily.model';
import { CommonService } from '@shared/service/common.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-carruseladmin',
  templateUrl: './carruseladmin.component.html',
  styleUrls: ['./carruseladmin.component.scss']
})
export class CarruseladminComponent implements OnInit {
  @Input() showRelatedProducts: number;
  @Input() showPromoProducts: number;
  @Input() showViewedProducts: number;
  @Input() showNewProducts: number;
  @Input() custAccount: string;

  private unsubscribe$ = new Subject<void>();
  relatedProducts: number;
  promoProducts: number;
  viewedProducts: number;
  newProducts: number;
  custAccountInput: string;
  productFamilyModel: ProductFamilyModel;
  familyId: string;

  constructor(
    private common: CommonService,
  ) { }

  ngOnInit(): void {

    this.relatedProducts = this.showRelatedProducts;
    this.promoProducts = this.showPromoProducts;
    this.viewedProducts = this.showViewedProducts;
    this.newProducts = this.showNewProducts;
    this.custAccountInput = this.custAccount;
  }

}
